import React from 'react';

import Footer from './Footer';
import TopBar from './Topbar';

const Missionpg = () => {
    const team = [
        {
            name: 'Molly Huyck',
            title: 'Founder / CEO',
            img: '/images/Molly.png',
            linkedin: 'https://www.linkedin.com/in/molly-huyck-0b90258/',
        },
        {
            name: 'Amie Konwinski',
            title: 'COO/CCO',
            img: '/images/Amie.png',
            linkedin: 'https://www.linkedin.com/in/amiekonwinski/',
        },
        {
            name: 'Janessa Nations',
            title: 'Client Success Manager',
            img: '/images/Janessa.png',
            linkedin: 'https://www.linkedin.com/in/janessanations/',
        },
    ];
    return (
        <>
            <TopBar />

            <main className='w-full'>
                {/* Section 1 */}
                <section className="bg-navy px-6 py-12 sm:py-16">
                    <div className="mx-auto max-w-7xl">
                        <h1 className="mx-auto mb-10 max-w-5xl text-center text-3xl font-semibold leading-tight text-white sm:text-[2.3rem] font-poppins">
                            We Raise for Women. We Welcome All.
                        </h1>

                        <br />

                        {/* Image & Text Row */}
                        <div className="flex flex-col items-center gap-10 md:flex-row md:gap-12">
                            {/* Image Left */}
                            <div className="w-full flex-shrink-0 md:w-[39%]">
                                <img
                                    src='/images/Mission-Page-team.png'
                                    alt='AQi Team'
                                    className="h-auto w-full rounded border border-[#D4AF37] shadow-lg"
                                />
                            </div>

                            {/* Text Right */}
                           <div className="w-full space-y-6 text-white md:flex-1">
                                <p className="font-poppins text-sm font-normal leading-relaxed text-white/90 lg:text-base">
                                    <strong className="font-medium text-[#D4AF37]">What Is AQi?</strong><br />
                                    AQi is a women-founded and led investment platform and Regulation Crowdfunding (Reg CF) funding portal built
                                    to increase visibility for women-led companies and make regulatory disclosures easier to understand. We provide a
                                    neutral platform where issuers post required Reg CF disclosures and investors can review them. AQi does not solicit
                                    investments, make recommendations, or provide investment, legal, or tax advice.<br/>
                                    Every offering hosted on AQi comes from a company that is at least 50% women-owned.
                                </p>
                                <p className="font-poppins text-sm font-normal leading-relaxed text-white/90 lg:text-base">

                                    <strong className="font-medium text-[#D4AF37]">Why AQi Exists?</strong><br />
                                    Women entrepreneurs remain persistently underfunded through traditional venture capital, and Reg CF disclosures
                                    can be hard to navigate for issuers and investors alike. AQi exists to close that gap: a dedicated home for
                                    crowdfunding for women entrepreneurs, offering a startup funding alternative for women that&#39;s built around clear,
                                    consistent, investor-friendly disclosure — not a pitch.<br/>
                                    We aspire to help close the funding gap for women-owned ventures and expand access to private-market investing,
                                    within the regulatory guardrails that govern every funding portal.<br />
                                    Additionally, our team provides a concierge-level service for issuers, assisting them through a complicated
                                    compliance process.
                                </p>

                            </div>

                        </div>
                    </div>
                </section>

                {/* Section 2 - Mission and Vision */}

                {/* Section 2.5 - About Our Platform */}
                <section className='bg-paper px-6 py-16'>
                    <div className='max-w-6xl mx-auto'>
                        <div className='text-navy'>
                            <p
                                className='text-base md:text-lg leading-relaxed mb-6'
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 400,
                                }}
                            >
                                <h3
                                    className="mb-4 text-[1.75rem] font-semibold text-navy md:text-[2rem]"
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    Who&#39;s Behind AQi?
                                </h3>
                                AQi is led by <strong>Molly Huyck</strong> (Founder/CEO, former FinTech executive and entrepreneur) and <strong>Amie Konwinski</strong>
                                (COO/CCO, U.S. Navy veteran, and marketing executive). Together, they built AQi to give investors a
                                straightforward way to explore women-owned ventures — and to give women-led companies a Reg CF platform
                                designed with them in mind.<br/>
                            </p>


                            <div className='mb-6'>
                                <h3
                                    className='mb-4 text-[1.75rem] font-semibold text-navy md:text-[2rem]'
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    How Does AQi Work?
                                </h3>

                                <div className='space-y-4 ml-2'>
                                    <div className='flex items-start'>
                                        <div className='flex-shrink-0 w-6 h-6 mr-3 mt-1 flex items-center justify-center'>
                                            <div className='w-3 h-3 bg-[#D4AF37] transform rotate-45'></div>
                                        </div>
                                        <p
                                            className='text-base md:text-lg leading-relaxed'
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 400,
                                            }}
                                        >
                                           <strong>For Everyone</strong>{" "} <br/>
                                            Think of AQi as the town square for business and investment — a neutral place where equity meets
                                            capital. We&#39;re not in the business of picking winners; we&#39;re the ground where companies raising money
                                            and the investors backing them show up and meet on equal footing, on their own terms.
                                        </p>
                                    </div>

                                    <div className='flex items-start'>
                                        <div className='flex-shrink-0 w-6 h-6 mr-3 mt-1 flex items-center justify-center'>
                                            <div className='w-3 h-3 bg-[#D4AF37] transform rotate-45'></div>
                                        </div>
                                        <p
                                            className='text-base md:text-lg leading-relaxed'
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 400,
                                            }}
                                        >
                                            <strong>For Issuers</strong> <br/>
                                            Each Issuer — a company raising capital — gets a dedicated campaign page to share its pitch deck,
                                            business plan, financials, and leadership team, and to tell the story of what problem the company solves and
                                            how the raised funds will be used. Every page follows a consistent, easy-to-navigate format that meets
                                            Reg CF disclosure requirements, with a robust Q&amp;A channel — open for any visitor to read, with
                                            comments reserved for account holders — to communicate directly with potential funders.
                                        </p>
                                    </div>

                                    <div className='flex items-start'>
                                        <div className='flex-shrink-0 w-6 h-6 mr-3 mt-1 flex items-center justify-center'>
                                            <div className='w-3 h-3 bg-[#D4AF37] transform rotate-45'></div>
                                        </div>
                                        <p
                                            className='text-base md:text-lg leading-relaxed'
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 400,
                                            }}
                                        >
                                            <strong>For Funders</strong>{" "} <br/>
                                            All qualified funders — accredited and non-accredited investors alike — are welcome to invest in
                                            companies in exchange for equity. Campaign pages show the details of each offering: minimum
                                            investment amounts, financials, and how the funds will be used to grow the company. Easy-to-find
                                            disclosures, accessible investor education, and an on-platform Q&amp;A channel — visible to any visitor, with
                                            commenting reserved for account holders — let funders evaluate an offering based on what the issuer
                                            has filed and shared with the community.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-6">
                                <h3
                                    className="mb-4 text-[1.75rem] font-semibold text-navy md:text-[2rem]"
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    Our Role
                                </h3>
                            <p
                                className='text-base md:text-lg leading-relaxed'
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 400,
                                }}
                            >
                                Think of AQi as the open marketplace for business and investment — a neutral venue where equity meets capital.
                                We&#39;re the marketplace, not a participant, and not the regulator (that&#39;s FINRA and the SEC). Issuers list, investors
                                browse, and both sides deal directly with each other, on their own terms — we don&#39;t broker the deal, solicit
                                investments, make recommendations, or provide advice. Nothing on this site is investment, legal, or tax advice.
                            </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* SECTION 3 — Team Grid */}
                <section className='bg-white text-navy px-4 sm:px-8 xl:px-16 py-16 font-poppins'>
                    <div className='max-w-7xl mx-auto text-center space-y-12'>
                        <h2 className='text-[1.75rem] font-semibold sm:text-[2rem]'>Meet our Team</h2>

                        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8'>
                            {team.map((member) => (
                                <figure
                                    key={member.name}
                                    className='flex flex-col items-center space-y-4'
                                >
                                    <div
                                        className='w-64 h-64 overflow-hidden shadow-md cursor-pointer transition-transform hover:scale-105'
                                        onClick={() =>
                                            window.open(
                                                member.linkedin,
                                                '_blank',
                                                'noopener,noreferrer'
                                            )
                                        }
                                        title={`Visit ${member.name}'s LinkedIn profile`}
                                    >
                                        <img
                                            src={member.img}
                                            alt={member.name}
                                            className='border-2 border-[#D4AF37] w-full h-full object-cover hover:opacity-90 transition-opacity'
                                        />
                                    </div>

                                    <figcaption className='space-y-1'>
                                        <p className='font-semibold text-lg text-[#D4AF37]'>
                                            {member.name}
                                        </p>
                                        <p className='text-sm opacity-80'>{member.title}</p>
                                    </figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </section>
            </main>

            <Footer />

            {/* Additional white space after footer */}
            <div className='h-12 bg-white'></div>
        </>
    );
};

export default Missionpg;
